/**
 * The koppeling vocabulary: who an account belongs to, and the persoon zoeker two screens share.
 * Not a screen of its own any more - the accounts that need linking are the Accounts list's
 * `wacht` filter, and the words for that strip live in `lokaleAccounts`.
 * See docs/adr/0018-identity-linking.md.
 */
export const koppelingen = {
  detail: {
    aanbieder: "Aanbieder",
    gebruiker: "gebruiker",
    eersteAanmelding: "Voor het eerst ingelogd op {{moment}}",
    /** A quotation, never a heading: on an open door the signer-in chooses both. */
    zegt: "Dit account zegt: ",
    geenNaam: "geen naam",
    onderdrukt:
      "Dit account is eerder ontkoppeld en koppelt niet meer vanzelf. Controleer eerst of het adres in het JBNL Portaal klopt.",
    koppelen: "Koppelen",
    ontkoppelen: "Ontkoppelen",
    ontkoppelenTitle: "Dit account ontkoppelen?",
    /** Says what stays broken afterwards, because correcting Portaal is the only way back. */
    ontkoppelenUitleg:
      "Daarna is het account aan niemand gekoppeld. Het koppelt ook niet meer vanzelf aan {{naam}}. Verbeter het adres in het JBNL Portaal en koppel het account hier opnieuw.",
    gedrift:
      "Deze koppeling is ooit vanzelf gemaakt. Het adres in het JBNL Portaal is sindsdien veranderd. De koppeling blijft geldig. Controleer wel of dit de juiste persoon is.",
    gekoppeldAan: "Gekoppeld aan <strong>{{naam}}</strong>",
    portaalAdres: " (in het JBNL Portaal staat nu {{email}})",
  },

  /** Counted in the title, as the VBS- and boekjewaarschuwing do: the banner says its own size. */
  duplicaten: {
    title_one: "1 e-mailadres in het JBNL Portaal staat op meer dan één persoon",
    title_other:
      "{{count}} e-mailadressen in het JBNL Portaal staan op meer dan één persoon",
    uitleg:
      "Een account met een gedeeld adres koppelt nooit vanzelf. De Wedstrijdplanner weet dan niet wie het is. Laat het dubbele adres in het JBNL Portaal verbeteren, of koppel het account hier met de hand.",
  },

  zoeker: {
    labelIedereen: "Zoek op naam of e-mailadres",
    labelNaam: "Zoek de persoon op naam",
    placeholderIedereen: "Naam of e-mailadres",
    placeholderNaam: "Achternaam of voornaam",
    minimaal: "Typ minimaal twee letters.",
    resultaten: "Gevonden personen",
    bezig: "Bezig met zoeken…",
    naam: "Naam",
    email: "E-mailadres",
    beheerder: " · Beheerder",
    leeg: "Geen personen gevonden. Staat deze persoon wel in het JBNL Portaal?",
  },

  errors: {
    zoeken: "Zoeken is mislukt ({{status}}).",
    duplicaten: "Kon de dubbele adressen niet ophalen ({{status}}).",
    koppelen: "Koppelen is mislukt ({{status}}).",
    ontkoppelen: "Ontkoppelen is mislukt ({{status}}).",
  },
} as const;
